exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notauthorized {\n  padding: 5% 8%;\n}\n\n.notauthorized-container > p {\n  text-align: left;\n}\n\n.notauthorized-block {\n  margin-bottom: 50px;\n}\n\n.rule-list {\n  padding: 5% 10%;\n}\n\n.rule-list > div > * {\n  flex: 1 1;\n  padding: 5% 0px;\n  text-align: left;\n}\n\n.notauthorized-block > div > img{\n  width: 100%;\n}\n\n.notauthorized-block > h3 {\n  text-align: left;\n  margin-left: 20px;\n}\n\n", ""]);

// exports
